<template>
  <div class="page" v-if="row">
    <!--店员信息-->
    <div style="display: flex;margin-bottom: 20px">
      <div style="width: 40%;">
        <ClerkInfo type="object" :info="row.myClerkInfo"/>
        <div style="margin-left: 5px" v-if="row.status===3">
          <van-tag v-if="!row.isDraw&&row.winnerId===row.myClerkInfo.id" plain type="warning">胜利</van-tag>
          <van-tag v-else-if="!row.isDraw&&row.winnerId!==row.myClerkInfo.id" plain type="danger">失败</van-tag>
          <van-tag v-else plain>平局</van-tag>
        </div>
      </div>
      <div class="pk">
        <div class="icon">
          <img src="/static/images/default/PK.png">
        </div>
        <div class="amount">
          <span style="color: red">{{ divide100(row.myClerkInfo.amount) }}</span>
          <span>VS</span>
          <span style="color: red">{{ divide100(row.pkClerkInfo.amount) }}</span>
        </div>
      </div>
      <div style="width: 40%;">
        <ClerkInfo type="object" :info="row.pkClerkInfo"/>
        <div style="margin-left: 5px" v-if="row.status===3">
          <van-tag v-if="!row.isDraw&&row.winnerId===row.pkClerkInfo.id" plain type="warning">胜利</van-tag>
          <van-tag v-else-if="!row.isDraw&&row.winnerId!==row.pkClerkInfo.id" plain type="danger">失败</van-tag>
          <van-tag v-else plain>平局</van-tag>
        </div>
      </div>
    </div>
    <div>
      <div>
        <span style="color: grey;margin: 5px">状态：</span>
        <van-tag v-if="row.status === 0"  plain type="danger" >等待中</van-tag>
        <van-tag v-if="row.status === 1" plain type="primary" >进行中</van-tag>
        <van-tag v-if="row.status === 2" plain type="warning" >统计中</van-tag>
        <van-tag v-if="row.status === 3" plain type="success" >已完成</van-tag>
      </div>
    </div>

    <div>
      <div style="color: grey;margin: 5px">创建时间:{{ formatDate(row.createTime, 'YYYY-MM-DD HH:mm') }}</div>
      <div style="color: grey;margin: 5px">开始时间:{{ formatDate(row.startTime, 'YYYY-MM-DD HH:mm') }}</div>
      <div style="color: grey;margin: 5px">结束时间：{{ formatDate(row.endTime, 'YYYY-MM-DD HH:mm') }}</div>
      <div style="color: grey;margin: 5px">惩罚公示结束时间：{{ formatDate(row.penaltyEndTime, 'YYYY-MM-DD HH:mm') }}</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {Dialog, List, Tag,  Cell, } from "vant"
import moment from "moment";
import {handlePromise} from "@/libs/util";
import {getPKInfo} from "../../../api/clerk/clerk-pk";
import Decimal from "decimal.js";
import ClerkInfo from '@/components/ClerkInfo';

Vue.use(List)
    .use(Cell)
    .use(Tag)


export default {
  name: "clerk-pk-info",
  components: {
    ClerkInfo,
  },
  data() {
    return {
      row:null
    }
  },

  methods: {
    divide100(amount) {
      return Decimal.div(amount, 100).toNumber()
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },

    loadData() {
      console.log("=============")
      handlePromise(getPKInfo(this.$route.params.id), (data) => {
        this.row=data.clerkPkInfo
      }, (data) => {
        this.loading = false
        Dialog.alert({title: '加载失败', message: data.msg})
      })
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>

<style scoped lang="less">
.page {
  padding: 2vw 4vw 0;
  margin-top: 20px;
  box-sizing: border-box;

  .list {

    .listItem {
      padding: 2.6vw 0;

    }
  }


  .pk {
    align-items: center;
    margin-top: 20px;
    text-align: center;

    .icon {
      img {
        width: 30px;
        height: 30px;
        margin: 0 10px;
        border-radius: 50%;
      }
    }

    .amount {

    }
  }
}
</style>
